export default "__VITE_ASSET__DqAsRR2F__"